export default __webpack_public_path__ + "static/media/medal.e9f82b1a.png";